export const DISCOUNT_CODE_TYPES = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED: 'FIXED',
};
